<template>
  <quick-filter-wrapper>
    <boat-launch-filter class="launch-filter" />
  </quick-filter-wrapper>
</template>
<!-- eslint-disable vue/block-lang -->
<script setup>
///// imports /////
import quickFilterWrapper from '@/components/activity-filtering/quick-filter-wrapper.vue'
import boatLaunchFilter from '@/fish/components/filtering/boat-launch-filter'
</script>
<style lang="scss" scoped>
.launch-filter {
  padding-top: var(--ys-spacing-300);
}
</style>
